// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2IDFI","validationTips":"StatementDescriptor_validationTips__CRZX7"};